import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$branding.data.code === 'default')?_c('div',{staticClass:"cancel-account-note"},[_c(VIcon,{attrs:{"size":"20","color":"text lighten-1"}},[_vm._v("$vuetify.icons.infotip_hot")]),_vm._v(" "),_c('span',{staticClass:"text--text text--lighten-1 w-caption"},[_vm._t("cancelText")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }